(function(config) {
    'use strict';

    angular.module('plate.services', [
            'ngResource',
        ])
        .factory('plateDataSrvc', plateDataSrvc)
        .factory('plateSrvc', plateSrvc);

    plateDataSrvc.$inject = ['$resource'];

    function plateDataSrvc($resource) {
        return $resource(config.api + '/api/v1/plates/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            montagePlates: {
                method: 'GET',
                url: config.api + '/api/v1/plates/admin_montage_plates/',
                isArray: true
            }
        });
    }

    plateSrvc.$inject = ['plateDataSrvc', 'modalSrvc'];

    function plateSrvc(plateDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    plateDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }
})(window.config);
